import { render, staticRenderFns } from "./ColorModule.vue?vue&type=template&id=e881b58c&scoped=true"
import script from "./ColorModule.vue?vue&type=script&lang=ts"
export * from "./ColorModule.vue?vue&type=script&lang=ts"
import style0 from "./ColorModule.vue?vue&type=style&index=0&id=e881b58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e881b58c",
  null
  
)

export default component.exports